const translations = {
  "en": {
    "Show all delisted tokens": "Show all delisted tokens"
  },
  "zh-tw": {
    "Show all delisted tokens": "顯示所有已下架的代幣"
  }
};

export default translations;
